// import { WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import { useState, useMemo, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { Flex } from 'components/common/flex/Flex'
import { Select } from 'components/common/select/Select'
import {
  roles,
} from 'components/documentsContainer/data'
import { Documents } from 'components/documentsContainer/documents/Documents'
import styles from 'components/documentsContainer/DocumentsContainer.module.scss'
import { TAB_DOCUMENT_MAP, tabs } from 'constants/documents-tabs.constants'


export const DocumentsContainer = () => {
  const location = useLocation()
  const [filterRole, setFilterRole] = useState(roles[0].value)
  const [activeTab, setActiveTab] = useState<typeof tabs[number]>(tabs[0])

  const searchParams = new URLSearchParams(location.search)
  const phase = searchParams.get('phase') || undefined

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const tabParam = searchParams.get('tab')
    const tabIndex = parseInt(tabParam ?? '0', 10)

    if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < tabs.length) {
      setActiveTab(tabs[tabIndex])
    }
  }, [location.search])

  const documents = useMemo(() => {
    return TAB_DOCUMENT_MAP[activeTab] || []
  }, [activeTab])

  return (
    <div className={styles.container}>
      <Flex justify="end">
        <Flex gap={16} align="center">
          <span  className={`${styles.roleFilterLabel} text-black font-medium uppercase`}>
            Filter by role
          </span>
          <Select options={roles} value={filterRole} onChange={e => setFilterRole(e.detail.value)} />
        </Flex>
      </Flex>
      <Flex className={styles.tabs}>
        {tabs.map((tab, index) => (
          <div onClick={() => setActiveTab(tab)} key={index}>
            <Flex direction="column" align="center" gap={15} className={styles.tab}>
              <span className={styles.tabText}>
                {tab}
              </span>
              <div className={clsx(styles.tabLine, activeTab === tab && styles.activeTabLine)} />
            </Flex>
          </div>
        ))}
      </Flex>
      <div className={styles.tabsLine} />
      <Documents documents={documents} roleFilter={filterRole} phase={phase} />
    </div>
  )
}
